import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { GetImmediateChildrenAsync } from "source/app/services/Workflows/GetImmediateChildren";

import { ArrayUtils } from "../ArrayUtils";
import { homeNode } from "motw_core/Repositories/WorkflowRepository";
import shuffle from "lodash-es/shuffle";

export async function GetRandomNodeAsync(rootNode: IWorkflowNode) {
    const hasRootNodeChanged =
        remainingRandomNodes.length > 0 &&
        rootNode.id !== remainingRandomNodes[0].parentid;

    const shouldReload =
        hasRootNodeChanged || remainingRandomNodes.length === 0;

    if (shouldReload) {
        var immediateChildren = await GetImmediateChildrenAsync(rootNode);
        remainingRandomNodes = shuffle(immediateChildren);
    }

    if (remainingRandomNodes.length > 0) {
        const randomNode = remainingRandomNodes[0];

        remainingRandomNodes = ArrayUtils.ExcludeByPropertyValue(
            remainingRandomNodes,
            "id",
            randomNode.id
        );

        return randomNode;
    } else {
        return homeNode;
    }
}

let remainingRandomNodes: IWorkflowNode[] = [];
